import PropTypes from "prop-types";
import React from "react";
import CollectionMixin from "./collection-mixin";
import { InfiniteScrollContainer, DragDropInfiniteScrollContainer } from "components/buzz-lightyear";

export default function ({ pageSize = 50, ...params } = {}) {
    return (Component) => {
        @CollectionMixin({ ...params, pageSize })
        class EnhancedComponent extends Component {
            constructor(props, context) {
                super(props, context);
                this.state = this.state || {};
                this.state.loading = false;
                this.state.hasMoreElements = true;

                if (!this.layoutManager) {
                    throw new Error("Layout Manager Required");
                }

                if (!this.ScollContainer) {
                    this.ScollContainer = this.layoutManager.hasDragAndDrop
                        ? DragDropInfiniteScrollContainer
                        : InfiniteScrollContainer;
                }

                this.handleInfiniteLoad = this.handleInfiniteLoad.bind(this);
            }

            handleInfiniteLoad() {
                if (!this.state.hasMoreElements) {
                    return;
                }
                this.fetchNextPage(false);
            }

            handleFetchSuccess(collection, data, options) {
                if (super.handleFetchSuccess) {
                    super.handleFetchSuccess(collection, data, options);
                }

                this.setState({
                    hasMoreElements: data.length === this.props.pageSize || data.length === pageSize,
                    loading: false,
                });
            }

            handleFetchError(collection, response, options) {
                if (super.handleFetchError) {
                    if (super.handleFetchError(collection, response, options) === false) {
                        return false;
                    }
                }

                const statusCode = response.rawRequest && response.rawRequest.status ? response.rawRequest.status : 500;
                if (statusCode < 500) {
                    this.setState({ hasMoreElements: false, loading: false });
                }

                return true;
            }

            onFetchNextPage(reset, props, context) {
                if (super.onFetchNextPage) {
                    super.onFetchNextPage(reset, props, context);
                }
                this.setState({ loading: true, hasMoreElements: true });
                if (reset) {
                    this.layoutManager.reset();
                }
            }

            getScrollContainer(props = {}) {
                const { ScollContainer } = this;
                const { loading, hasMoreElements } = this.state;
                const { onDrag, onDrop, ...rest } = props;

                return (
                    <ScollContainer
                        loading={loading}
                        hasMoreElements={hasMoreElements}
                        layoutManager={this.layoutManager}
                        onLoadMoreRows={this.handleInfiniteLoad}
                        onDrag={(dragIndex) => {
                            if (onDrag) {
                                onDrag(dragIndex);
                            }
                        }}
                        onDrop={(dragIndex, hoverIndex) => {
                            if (onDrop) {
                                onDrop(dragIndex, hoverIndex);
                            }
                        }}
                        {...rest}
                    />
                );
            }
        }

        EnhancedComponent.contextTypes = {
            store: PropTypes.object.isRequired,
            ...EnhancedComponent.contextTypes,
        };

        return EnhancedComponent;
    };
}
